export function getPercentage(
  value: number,
  total: number,
  fractionDigits?: number | undefined,
): number {
  return total === 0
    ? NaN
    : parseFloat(((value / total) * 100).toFixed(fractionDigits));
}
